import { createFileRoute } from '@tanstack/react-router';
import { CarriersLayout } from '@uturn/portal/modules/carriers/layout';

export const Route = createFileRoute('/_protected/carriers')({
	component: CarriersLayout,
});
